<template>
  <div
    ref="root"
    class="custom-select"
  >
    <v-menu
      v-model="menu"
      class="custom-select__menu"
      :transition="false"
      :attach="rootElement"
      :close-on-content-click="false"
      offset-y
    >
      <template #activator="{ on, attr }">
        <div
          v-bind="attr"
          class="custom-select__activator"
          v-on="on"
        >
          <v-text-field
            v-bind="$attrs"
            class="text-body-1 text--text"
            :label="label"
            :value="selectedItem.text"
            readonly
            outlined
            hide-details
          >
            <template #append>
              <v-icon class="custom-select__chevron">
                ui-icon-arrow-down
              </v-icon>
            </template>
          </v-text-field>
        </div>
      </template>

      <menu-search
        v-if="search"
        v-model="searchQuery"
        placeholder="Найти"
      />

      <v-divider />

      <div
        v-if="searchResultsCount === 0"
        class="custom-select__items custom-select__items_empty d-flex flex-column justify-center align-center"
      >
        <img
          class="mb-5"
          src="/static/_v1/pd/icons/empty-search-result/common.svg"
          width="60"
          height="60"
        >
        <span class="text-body-1 text--text">Мы ничего не нашли</span>
      </div>
      <div
        class="custom-select__items"
        :class="{ 'custom-select__items_scroll': scroll && items.length > 4 }"
      >
        <selection-list
          :items="items"
          :value="value"
          :mandatory="mandatory"
          :search-query="searchQuery"
          small-items
          hover
          @change="handleSelect"
        />
      </div>
    </v-menu>
  </div>
</template>

<script>
import MenuSearch from 'www/vue_components/desktop/core/MenuSearch.vue'
import SelectionList from 'www/vue_components/common/core/SelectionList.vue'

export default {
  name: 'CustomSelect',
  components: {
    MenuSearch,
    SelectionList,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [Object, String],
      default: 'any',
    },
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    search: Boolean,
    mandatory: Boolean,
    scroll: Boolean,
  },
  data() {
    return {
      menu: false,
      searchQuery: '',
      selectedItem: {},
      rootElement: null,
    }
  },
  computed: {
    searchResultsCount() {
      return this.items.reduce((sum, item) => sum + (this.matchSearchQuery(item) ? 1 : 0), 0)
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selectedItem = this.items.find(item => item.value === val)
      },
    },
  },
  mounted() {
    this.rootElement = this.$refs.root
  },
  methods: {
    openMenu() {
      this.menu = true
    },
    closeMenu() {
      this.menu = false
      this.clearSearchQuery()
    },
    handleSelect(value) {
      this.$emit('change', value)
      this.closeMenu()
    },
    matchSearchQuery(item) {
      return new RegExp(this.searchQuery.trim(), 'i').test(item.text)
    },
    clearSearchQuery() {
      this.searchQuery = ''
    },
  },
}
</script>

<style lang="scss">
.custom-select__activator .v-input {
  .v-input__slot,
  input {
    cursor: pointer;
  }
}
</style>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.v-menu__content {
  @include elevation-8;

  border-radius: 4px;
  background-color: $ui-kit-bg-gray-0;
}

.custom-select {
  user-select: none;
  position: relative;

  &__items {
    &_scroll {
      max-height: 248px;
      overflow: hidden auto;
    }

    &_empty {
      height: 248px;
    }
  }

  &__chevron {
    color: $ui-kit-text-secondary;
  }
}
</style>
